// using module.exports here so gatsby-config can read it
module.exports = {
  builderAPIKey: "52e25e31211c4830b58c9015acc38de9" // Use client's public builder.io key
};
